import { Component ,OnInit} from '@angular/core';
@Component({
  selector: 'dashboard-cmp',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
      
}
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts